import { useEffect, useRef, useState } from 'react';
import React from 'react';
import IKEAImage from "../../assets/image/ikea.svg";
import { useSearchParams } from 'react-router-dom';
import './ConsultationStep.scss';
import axios from 'axios';
import ServiceSelectionStep1 from '../../components/booking/steps/Step1_ServiceSelection';
import AppointmentStep3 from '../../components/booking/steps/Step3_Appointment';
import CustomerDetailsStep2 from '../../components/booking/steps/Step2_CustomerDetails';
import BookingSummaryStep4 from '../../components/booking/steps/Step4_BookingSummary';
import ConfirmationStep5 from '../../components/booking/steps/Step6_Confirmation';
import StepNavigation from './StepNavigation';
import { Emirateslist, NumberofRooms, ServiceMode } from '../../constants/dropdownOptions';
import { generateBookingSession } from '../../utils/generateBookingSession';
import TermsAndConditionsPage from '../../components/booking/steps/Step5_TermsConditions';
import { useFetchServices } from '../../hooks/useFetchServices';
import { useFetchStoreLocations } from '../../hooks/useFetchStoreLocations';
import Loader from '../../loader/Loader';
import IDChoiceStep from '../../components/booking/steps/Step_IDChoice';
import IDEnquiryStep from '../../components/booking/steps/Step_IDEnquiry';
import IDEnquiryConfirmStep from '../../components/booking/steps/Step_IDEnquiryConfirm';

const PHONE_PATTERN = /^9715[0-9]{8}$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

const isInteriorDesign = (service) =>
  service?.ServiceName?.toLowerCase().includes('interior design');

export default function ConsultationStep() {
  const [searchParams] = useSearchParams();

  // --- Booking session ---
  const [randomID, setRandomID] = useState('');
  const [skey, setSKEY] = useState();

  // --- Step navigation ---
  const [step, setStep] = useState(1);

  // --- Selected service ---
  const [selectedService, setSelectedService] = useState('');
  const [ServiceDescription, setServiceDescription] = useState();
  const [ServicePrice, setServicePrice] = useState();
  const [ServiceName, setServiceName] = useState('');

  // --- Booking outcome ---
  const [bookingId, setBookingId] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  const [TransactionID, setTransactionID] = useState();

  // --- Customer details ---
  const [customerFirstName, setCustomerFirstName] = useState('');
  const [customerLastName, setCustomerLastName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [building, setBuilding] = useState('');
  const [area, setArea] = useState('');
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [inUAE, setInUAE] = useState(true);
  const [error, setError] = useState('');
  const [emailError, setEmailError] = useState('');

  // --- Reference number (Kitchen Planning Service) ---
  const [referenceNumber, setReferenceNumber] = useState('');
  const [showReference, setshowReference] = useState(false);
  const [showReferenceWarning, setShowReferenceWarning] = useState(false);
  const [refAvailable, setrefAvailable] = useState(false);
  const [creatorrefnumpresent, setCreatorRefNumPresent] = useState();
  const [isManualReferenceEntry, setIsManualReferenceEntry] = useState(false);
  const [referenceOptions, setReferenceOptions] = useState([]);
  const [MeasurementServiceDateforPlanning, setMeasurementServiceDateforPlanning] = useState();

  // --- Appointment (Step 3) ---
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedSlot, setSelectedSlot] = useState('');
  const [selectedStore, setSelectedStore] = useState();
  const [StoreLocationString, setStoreLocationString] = useState();
  const [selectedNumberofRooms, setselectedNumberofRooms] = useState();
  const [selectedServiceMode, setSelectedServiceMode] = useState();
  const [totalPrice, setTotalPrice] = useState(null);

  // --- Services & stores ---
  const [Services, setServices] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [page] = useState(1);
  const [StoreLocation, setStoreLocation] = useState([]);
  const [fetchState, setFetchState] = useState('init');
  const [fetchStoreLocation, setfetchStoreLocation] = useState('init');
  const [storePage] = useState(1);

  // --- Interior Design state ---
  const [idChoice, setIdChoice] = useState('');
  const [idEnquiryPhone, setIdEnquiryPhone] = useState('');
  const [idEnquiryEmail, setIdEnquiryEmail] = useState('');
  const [idEnquiryFirstName, setIdEnquiryFirstName] = useState('');
  const [idEnquiryLastName, setIdEnquiryLastName] = useState('');
  const [idEnquiryBuilding, setIdEnquiryBuilding] = useState('');
  const [idEnquiryArea, setIdEnquiryArea] = useState(null);
  const [idEnquiryCity, setIdEnquiryCity] = useState(null);
  const [idEnquiryStore, setIdEnquiryStore] = useState('');
  const [idEnquiryComments, setIdEnquiryComments] = useState('');
  const [idResidenceType, setIdResidenceType] = useState('');
  const [idRooms, setIdRooms] = useState([{ roomType: '', quantity: 1 }]);
  const [idEnquiryPhoneError, setIdEnquiryPhoneError] = useState('');
  const [idEnquiryEmailError, setIdEnquiryEmailError] = useState('');

  // --- UI state ---
  const [loading, setLoading] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [formError, setFormError] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);

  // --- Step 2 refs (for scroll-to-error) ---
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);
  const buildingRef = useRef(null);
  const areaRef = useRef(null);
  const emirateRef = useRef(null);
  const incountryRef = useRef(null);
  const referencenumRef = useRef(null);

  // --- Step 3 refs ---
  const storeRef = useRef(null);
  const numberofRoomsRef = useRef(null);
  const serviceModeRef = useRef(null);
  const calendarRef = useRef(null);

  const hasFetched = useRef(false);

  // --- URL param handling (resume after payment redirect) ---
  useEffect(() => {
    setSKEY(searchParams.get('skey'));
    const resume = searchParams.get('resume');
    const stepParam = searchParams.get('step');
    if (resume) {
      setLoading(true);
      setStep(6);
    }
    if (stepParam === '6' && resume && resume.trim() !== '') {
      fetchTempRecByToken(resume);
    }
  }, [searchParams]);

  useFetchServices(setServices, setHasMore, setFetchState, page, hasFetched);
  useFetchStoreLocations(setStoreLocation, fetchStoreLocation, setfetchStoreLocation, storePage);

  // Reset reference-number state whenever the selected service is not Kitchen Planning
  useEffect(() => {
    if (selectedService?.ServiceName !== 'Kitchen Planning Service') {
      setshowReference(false);
      setReferenceNumber('');
      setReferenceOptions([]);
    }
  }, [selectedService]);

  // Flat pricing for Interior Design
  useEffect(() => {
    if (isInteriorDesign(selectedService) && selectedService?.Price) {
      setTotalPrice(parseFloat(selectedService.Price));
    }
  }, [selectedService]);

  // Generate a unique booking session token when the app first loads (step 1)
  useEffect(() => {
    if (step !== 1) return;
    generateBookingSession()
      .then(setRandomID)
      .catch(console.error);
  }, [step]);

  // -------------------------------------------------------------------------
  // Phone validation + reference number lookup (Kitchen Planning Service)
  // -------------------------------------------------------------------------
  const validatePhone = async (value) => {
    setReferenceNumber('');
    setshowReference(false);

    const digitsOnly = value.replace(/\D/g, '');
    const fullPhone = `971${digitsOnly}`;

    if (!PHONE_PATTERN.test(fullPhone)) {
      setError('Enter a valid UAE phone number (e.g., 501234567)');
      return;
    }

    setError('');
    setCustomerPhone(digitsOnly);

    if (selectedService?.ServiceName !== 'Kitchen Planning Service') {
      setshowReference(false);
      return;
    }

    setReferenceOptions([]);
    setLoading(true);
    try {
      const resp = await axios.post('/server/creator_api_proxy', {
        action: 'fetchReferenceNumber',
        refcheck: fullPhone,
        UniqueID: randomID,
      });

      const referenceData = resp?.data?.data;

      if (referenceData) {
        const [ref, date] = referenceData.split('||');
        const parsedDate = new Date(date);

        const processedOptions = referenceData.split(',').map((entry) => {
          const [val, entryDate] = entry.split('||');
          return {
            value: `${val.trim()} (${entryDate.trim()})`,
            label: `${val.trim()} (${entryDate.trim()})`,
          };
        });

        setReferenceNumber(ref || '');
        setReferenceOptions(processedOptions);
        setMeasurementServiceDateforPlanning(parsedDate);
        setIsManualReferenceEntry(false);
        setrefAvailable(true);
        setshowReference(true);
        setCreatorRefNumPresent(true);
      } else {
        setReferenceNumber('');
        setshowReference(true);
        setCreatorRefNumPresent(false);
        setIsManualReferenceEntry(true);
      }
    } catch (e) {
      console.error('Error fetching reference number:', e.response?.data || e.message);
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------------------------------------------------
  // Manual reference number validation
  // -------------------------------------------------------------------------
  const ReferenceNumberValidation = async (value) => {
    if (selectedService?.ServiceName !== 'Kitchen Planning Service') return;
    try {
      const resp = await axios.post('/server/creator_api_proxy', {
        action: 'fetchReferenceNumber',
        refcheck: 'ref' + value,
        UniqueID: randomID,
      });

      const referenceData = resp?.data?.data;

      if (referenceData.includes('Available')) {
        const [, date] = referenceData.split('||');
        setrefAvailable(true);
        setMeasurementServiceDateforPlanning(new Date(date));
      } else {
        setrefAvailable(false);
        setShowReferenceWarning(true);
      }
    } catch (e) {
      console.error('Error validating reference number:', e.response?.data || e.message);
    }
  };

  // -------------------------------------------------------------------------
  // Email validation
  // -------------------------------------------------------------------------
  const validateEmail = (value) => {
    setEmailError(EMAIL_PATTERN.test(value) ? '' : 'Enter a valid email address');
    setCustomerEmail(value);
  };

  // -------------------------------------------------------------------------
  // Field change handlers
  // -------------------------------------------------------------------------
  const handleStoreLocationChange = (option) => {
    setSelectedStore(option);
    setStoreLocationString(option.StoreLocation);
    setSelectedDate('');
    setSelectedSlot('');
  };

  const handleEmirateChange = (option) => {
    // Reserved for future use
  };

  const handleNumberofRoomsChange = (option) => setselectedNumberofRooms(option);
  const handleServiceModeChange = (option) => setSelectedServiceMode(option);

  // -------------------------------------------------------------------------
  // Step navigation
  // -------------------------------------------------------------------------
  const handleIDChoice = (choice) => {
    setIdChoice(choice);
    if (choice === 'enquiry') {
      setStep(8);
    } else {
      setStep(2);
    }
  };

  const handleNextStep = () => {
    if (!isStepValid()) {
      setFormError('Please fill all the details');
      setShowErrors(true);
      return;
    }
    setFormError('');

    if (step === 1) {
      setStep(isInteriorDesign(selectedService) ? 7 : 2);
      return;
    }

    if (step === 2) {
      const isValid = validateAndScrollToFirstError();
      if (isValid) {
        setShowErrors(false);
        setStep(3);
      } else {
        setShowErrors(true);
      }
      return;
    }

    if (step === 8) {
      setStep(9);
      return;
    }

    if (step === 4) {
      setConfirmed(true);
    }
    setStep((prev) => prev + 1);
  };

  const isStepValid = () => {
    if (step === 1) return !!selectedService;

    if (step === 2) {
      return (
        !!customerFirstName.trim() &&
        !!customerLastName.trim() &&
        !!customerPhone.trim() &&
        !!customerEmail.trim() &&
        !!building.trim() &&
        !!selectedArea?.value &&
        !!selectedCity?.value
      );
    }

    if (step === 3) {
      const isBaseValid = !!selectedDate && !!selectedSlot && !!selectedStore;

      if (isInteriorDesign(selectedService)) {
        return (
          isBaseValid &&
          !!idResidenceType &&
          idRooms.length > 0 &&
          idRooms.every((r) => r.roomType && r.quantity)
        );
      }
      if (selectedService?.ServiceName === 'Measurement Service') {
        return isBaseValid && !!selectedNumberofRooms?.value;
      }
      if (selectedService?.ServiceName === 'Kitchen Planning Service') {
        return isBaseValid && !!selectedServiceMode?.value;
      }
      return isBaseValid;
    }

    if (step === 7) return !!idChoice;

    if (step === 8) {
      return (
        !!idEnquiryPhone.trim() &&
        !idEnquiryPhoneError &&
        !!idEnquiryEmail.trim() &&
        !idEnquiryEmailError &&
        EMAIL_PATTERN.test(idEnquiryEmail) &&
        !!idEnquiryFirstName.trim() &&
        !!idEnquiryLastName.trim() &&
        !!idEnquiryBuilding.trim() &&
        !!idEnquiryArea?.value &&
        !!idEnquiryCity?.value &&
        !!idEnquiryStore
      );
    }

    if (step === 5) return !!termsAccepted;
    return true;
  };

  // Scroll to and highlight the first invalid field on Step 2
  const validateAndScrollToFirstError = () => {

    const fields = [
      { value: customerFirstName.trim(), ref: firstNameRef },
      { value: customerLastName.trim(), ref: lastNameRef },
      { value: customerPhone.trim(), ref: phoneRef, type: 'phone' },
      { value: customerEmail.trim(), ref: emailRef, type: 'email' },
      { value: building.trim(), ref: buildingRef },
      { value: selectedArea?.value, ref: areaRef },
      { value: selectedCity?.value, ref: emirateRef },
    ];

    if (typeof inUAE !== 'boolean') {
      fields.push({ value: '', ref: incountryRef });
    }

    if (
      selectedService?.ServiceName === 'Kitchen Planning Service' &&
      showReference &&
      (!referenceNumber.trim() || !refAvailable)
    ) {
      fields.push({ value: '', ref: referencenumRef });
    }

    for (const field of fields) {
      let isInvalid = false;

      if (field.type === 'phone') {
        isInvalid = !PHONE_PATTERN.test('971' + field.value.trim());
      } else if (field.type === 'email') {
        isInvalid = !EMAIL_PATTERN.test(field.value.trim());
      } else {
        isInvalid = !field.value;
      }

      if (isInvalid) {
        field.ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        field.ref.current?.focus?.();
        return false;
      }
    }

    return true;
  };

  // -------------------------------------------------------------------------
  // API: Create temporary record (holds booking data during payment)
  // -------------------------------------------------------------------------
  const createTempRec = async () => {
    const response = await axios.post('/server/ikea_services_function/addtempRec', {
      ServiceName: selectedService.ServiceName,
      CustomerFirstName: customerFirstName,
      CustomerLastName: customerLastName,
      CustomerPhoneNumber: customerPhone,
      CustomerEmail: customerEmail,
      CustomerAddressBuilding_Villa: building,
      CustomerAddressArea: selectedArea?.value,
      CustomerAddressCity: selectedCity?.value,
      StoreLocation: selectedStore?.StoreLocation,

      ...(selectedService.ServiceName === 'Measurement Service' && {
        Number_of_Rooms_for_Measurement: selectedNumberofRooms.value,
      }),

      ...(selectedService.ServiceName === 'Kitchen Planning Service' && {
        Reference_Number_for_Planning_Service: referenceNumber,
        Service_Mode: selectedServiceMode.value,
      }),

      ServiceDate: selectedDate,
      TimeSlot: selectedSlot,
      UniqueID: randomID,
      ServiceDescription: ServiceDescription,
      ServicePrice: selectedService.ServiceName === 'Measurement Service' ? totalPrice : ServicePrice,
      StoreLocationString: StoreLocationString,
      Customer_Type: inUAE ? 'In Country' : 'Out of Country',
    });

    const { data: { todoItem } } = response.data;
    return todoItem.id;
  };

  // -------------------------------------------------------------------------
  // API: Initiate payment (redirects user to payment gateway)
  // -------------------------------------------------------------------------
  const handleConfirmPayment = async () => {
    setLoading(true);
    try {
      const rowId = await createTempRec();

      const payload = {
        action: 'paymentAPI',
        Customer_Name_First_Name: customerFirstName,
        Customer_Name_Last_Name: customerLastName,
        Mobile_Number: customerPhone,
        Email: customerEmail,
        Customer_Address_Building: building,
        Customer_Address_Area: selectedArea?.value,
        Customer_Address_City: selectedCity?.value,
        Service_Type: selectedService.ServiceName,
        Total_Price: totalPrice,
        Store_Location_string: StoreLocationString,
        Select_Service_Date: selectedDate,
        Select_a_time_slot: selectedSlot,
        UniqueID_to_Link_Appointment: randomID,
        Customer_Type: inUAE ? 'In Country' : 'Out of Country',
        ...(selectedService.ServiceName === 'Kitchen Planning Service' && {
          Service_Mode: selectedServiceMode.value,
        }),
        ...(selectedService.ServiceName === 'Measurement Service' && {
          Number_of_Rooms: selectedNumberofRooms.value,
        }),
      };

      const resp = await axios.post('/server/creator_api_proxy', payload);
      const parsedResponse = JSON.parse(resp.data.data);
      const transaction = parsedResponse?.Transaction;
      const description = transaction?.ResponseDescription;
      const paymentUrl = transaction?.PaymentPortal;
      const transactionId = transaction?.TransactionID;

      if (description === 'Request Processed Successfully' && paymentUrl) {
        await axios.patch('/server/ikea_services_function/updatetempRec', {
          ROWID: rowId,
          TransactionID: transactionId,
          UniqueID: randomID,
        });
        try {
          const parsed = new URL(paymentUrl);
          if (parsed.protocol !== 'https:' || parsed.hostname !== 'ipg.comtrust.ae') {
            throw new Error('Untrusted payment URL');
          }
          window.location.href = paymentUrl;
        } catch {
          alert('Payment initialization failed. Please contact support.');
        }
      } else {
        alert('Payment could not be processed. Please try again or call 800 4532.');
      }
    } catch (e) {
      console.error('Payment API error:', e.response?.data || e.message);
      alert('Something went wrong while initiating the payment.');
    } finally {
      setLoading(false);
    }
  };

  // -------------------------------------------------------------------------
  // API: Resume booking after payment redirect (exchange one-time token)
  // -------------------------------------------------------------------------
  const fetchTempRecByToken = async (resumeToken) => {
    try {
      const response = await axios.get('/server/ikea_services_function/exchangeResume', {
        params: { token: resumeToken },
      });

      const { tempRec } = response.data.data;

      if (!tempRec) return;

      setArea(tempRec.CustomerAddressArea);
      setBuilding(tempRec.CustomerAddressBuilding_Villa);
      setSelectedCity({ value: tempRec.CustomerAddressCity, label: tempRec.CustomerAddressCity });
      setSelectedArea({ value: tempRec.CustomerAddressArea, label: tempRec.CustomerAddressArea });
      setCustomerEmail(tempRec.CustomerEmail);
      setCustomerFirstName(tempRec.CustomerFirstName);
      setCustomerLastName(tempRec.CustomerLastName);
      setCustomerPhone(tempRec.CustomerPhoneNumber);
      setselectedNumberofRooms({ value: tempRec.Number_of_Rooms_for_Measurement, label: tempRec.Number_of_Rooms_for_Measurement });
      setReferenceNumber(tempRec.Reference_Number_for_Planning_Service);
      setSelectedDate(tempRec.ServiceDate);
      setSelectedServiceMode({ value: tempRec.Service_Mode, label: tempRec.Service_Mode });
      setSelectedStore(tempRec.StoreLocation);
      setSelectedSlot(tempRec.TimeSlot);
      setServiceName(tempRec.ServiceName);
      setServiceDescription(tempRec.ServiceDescription);
      setServicePrice(tempRec.ServicePrice);
      setStoreLocationString(tempRec.StoreLocationString);
      setRandomID(tempRec.UniqueID);
      setTransactionID(tempRec.TransactionID);

      await addBookingtoCreator(tempRec);
      setConfirmed(true);
    } catch (error) {
      console.error('Failed to exchange resume token:', error.response?.data || error);
    }
  };

  // -------------------------------------------------------------------------
  // API: Write confirmed booking to Zoho Creator, then clean up temp record
  // -------------------------------------------------------------------------
  const addBookingtoCreator = async (rec) => {
    setLoading(true);
    try {
      const payload = {
        action: 'BookingAPI',
        Customer_Name_First_Name: rec.CustomerFirstName,
        Customer_Name_Last_Name: rec.CustomerLastName,
        Mobile_Number: rec.CustomerPhoneNumber,
        Email: rec.CustomerEmail,
        Customer_Address_Building: rec.CustomerAddressBuilding_Villa,
        Customer_Address_Area: rec.CustomerAddressArea,
        Customer_Address_City: rec.CustomerAddressCity,
        Service_Type: rec.ServiceName,
        Total_Price: rec.ServicePrice,
        Store_Location_string: rec.StoreLocationString,
        Select_Service_Date: rec.ServiceDate,
        Select_a_time_slot: rec.TimeSlot,
        UniqueID_to_Link_Appointment: rec.UniqueID,
        TransactionID: rec.TransactionID,
        Customer_Type: rec.Customer_Type,
        Language: rec.Language,
        Reference_number: rec.Reference_Number_for_Planning_Service,
        ...(rec.ServiceName === 'Kitchen Planning Service' && { Service_Mode: rec.Service_Mode }),
        ...(rec.ServiceName === 'Measurement Service' && { Number_of_Rooms: rec.Number_of_Rooms_for_Measurement }),
      };

      const resp = await axios.post('/server/creator_api_proxy', payload);

      let bookingResult;
      if (resp.data.data === 'Failure') {
        bookingResult = 'Failure';
      } else if (resp.data.data === 'Booking Exists') {
        bookingResult = 'Booking Exists';
      } else {
        try {
          bookingResult = JSON.parse(resp.data.data);
        } catch {
          bookingResult = 'Failure';
        }
      }

      if (!bookingResult || bookingResult === 'Failure') {
        setBookingId('Failure');
        return;
      }

      if (bookingResult === 'Booking Exists') {
        setBookingId('Booking Exists');
        return;
      }

      setBookingId(bookingResult);

      if (rec.UniqueID) {
        try {
          await axios.delete('/server/ikea_services_function/deletetemprec', {
            params: { uniqueId: rec.UniqueID },
          });
        } catch (deleteError) {
          console.warn('Booking succeeded but failed to delete temp record:', deleteError.response?.data || deleteError.message);
        }
      }
    } catch (e) {
      console.error('Booking API error:', e.response?.data || e.message);
      setBookingId('Failure');
    } finally {
      setConfirmed(true);
      setStep(6);
      setLoading(false);
    }
  };

  // -------------------------------------------------------------------------
  // Render
  // -------------------------------------------------------------------------
  return (
    <div className="stepper-container">
      <img src={IKEAImage} alt="IKEA" />

      <>
        <div className={`main-header ${step >= 5 || step === 7 || step === 8 || step === 9 ? 'hide' : ''}`}>
          <h2>
            {step === 1 && 'Select Your Consultation Type'}
            {step === 2 && 'Customer Details'}
            {step === 3 && 'Schedule Your Appointment'}
            {step === 4 && 'Booking Summary'}
          </h2>

          <div className="stepper-card">
            {[1, 2, 3, 4].map((s) => (
              <span
                key={s}
                className={s < step ? 'complete' : s === step ? 'active' : ''}
              />
            ))}
          </div>
        </div>

        {step === 7 && (
          <div className="main-header">
            <h2>Interior Design</h2>
          </div>
        )}

        {step === 8 && (
          <div className="main-header">
            <h2>Interior Design Enquiry</h2>
          </div>
        )}

        {formError && <p className="text-red-500 text-sm mb-2">{formError}</p>}

        {step === 1 && (
          <ServiceSelectionStep1
            Services={Services}
            selectedService={selectedService}
            fetchState={fetchState}
            setSelectedService={setSelectedService}
            setServiceName={setServiceName}
            setServiceDescription={setServiceDescription}
            setServicePrice={setServicePrice}
            skey={skey}
          />
        )}

        {step === 2 && (
          <CustomerDetailsStep2
            Services={Services}
            selectedService={selectedService}
            customerFirstName={customerFirstName}
            inUAE={inUAE}
            setInUAE={setInUAE}
            setCustomerFirstName={setCustomerFirstName}
            setReferenceNumber={setReferenceNumber}
            customerLastName={customerLastName}
            setCustomerLastName={setCustomerLastName}
            customerPhone={customerPhone}
            setCustomerPhone={setCustomerPhone}
            setrefAvailable={setrefAvailable}
            showReferenceWarning={showReferenceWarning}
            setMeasurementServiceDateforPlanning={setMeasurementServiceDateforPlanning}
            referenceOptions={referenceOptions}
            setShowReferenceWarning={setShowReferenceWarning}
            ReferenceNumberValidation={ReferenceNumberValidation}
            isManualReferenceEntry={isManualReferenceEntry}
            setIsManualReferenceEntry={setIsManualReferenceEntry}
            creatorrefnumpresent={creatorrefnumpresent}
            refAvailable={refAvailable}
            goToStep={setStep}
            validatePhone={validatePhone}
            customerEmail={customerEmail}
            setCustomerEmail={setCustomerEmail}
            validateEmail={validateEmail}
            referenceNumber={referenceNumber}
            showReference={showReference}
            building={building}
            setBuilding={setBuilding}
            area={area}
            setArea={setArea}
            Emirateslist={Emirateslist}
            handleEmirateChange={handleEmirateChange}
            showErrors={showErrors}
            error={error}
            emailError={emailError}
            selectedCity={selectedCity}
            setSelectedCity={setSelectedCity}
            selectedArea={selectedArea}
            setSelectedArea={setSelectedArea}
            loading={loading}
            refs={{
              firstNameRef,
              lastNameRef,
              phoneRef,
              emailRef,
              buildingRef,
              areaRef,
              emirateRef,
              incountryRef,
              referencenumRef,
            }}
          />
        )}

        {step === 3 && (
          <AppointmentStep3
            Services={Services}
            setTotalPrice={setTotalPrice}
            selectedService={selectedService}
            selectedStore={selectedStore}
            handleStoreLocationChange={handleStoreLocationChange}
            StoreLocation={StoreLocation}
            NumberofRooms={NumberofRooms}
            selectedNumberofRooms={selectedNumberofRooms}
            handleNumberofRoomsChange={handleNumberofRoomsChange}
            ServiceMode={ServiceMode}
            selectedServiceMode={selectedServiceMode}
            handleServiceModeChange={handleServiceModeChange}
            selectedDate={selectedDate}
            selectedSlot={selectedSlot}
            setSelectedDate={setSelectedDate}
            MeasurementServiceDateforPlanning={MeasurementServiceDateforPlanning}
            setSelectedSlot={setSelectedSlot}
            randomID={randomID}
            idResidenceType={idResidenceType}
            setIdResidenceType={setIdResidenceType}
            idRooms={idRooms}
            setIdRooms={setIdRooms}
            refs={{
              storeRef,
              numberofRoomsRef,
              serviceModeRef,
              calendarRef,
            }}
          />
        )}

        {step === 7 && (
          <IDChoiceStep onChoose={handleIDChoice} />
        )}

        {step === 8 && (
          <IDEnquiryStep
            idEnquiryPhone={idEnquiryPhone}
            setIdEnquiryPhone={setIdEnquiryPhone}
            idEnquiryEmail={idEnquiryEmail}
            setIdEnquiryEmail={setIdEnquiryEmail}
            idEnquiryFirstName={idEnquiryFirstName}
            setIdEnquiryFirstName={setIdEnquiryFirstName}
            idEnquiryLastName={idEnquiryLastName}
            setIdEnquiryLastName={setIdEnquiryLastName}
            idEnquiryBuilding={idEnquiryBuilding}
            setIdEnquiryBuilding={setIdEnquiryBuilding}
            idEnquiryArea={idEnquiryArea}
            setIdEnquiryArea={setIdEnquiryArea}
            idEnquiryCity={idEnquiryCity}
            setIdEnquiryCity={setIdEnquiryCity}
            idEnquiryStore={idEnquiryStore}
            setIdEnquiryStore={setIdEnquiryStore}
            idEnquiryComments={idEnquiryComments}
            setIdEnquiryComments={setIdEnquiryComments}
            StoreLocation={StoreLocation}
            showErrors={showErrors}
            phoneError={idEnquiryPhoneError}
            setPhoneError={setIdEnquiryPhoneError}
            emailError={idEnquiryEmailError}
            setEmailError={setIdEnquiryEmailError}
          />
        )}

        {step === 9 && (
          <IDEnquiryConfirmStep
            idEnquiryFirstName={idEnquiryFirstName}
            idEnquiryLastName={idEnquiryLastName}
            idEnquiryPhone={idEnquiryPhone}
            idEnquiryEmail={idEnquiryEmail}
            idEnquiryBuilding={idEnquiryBuilding}
            idEnquiryArea={idEnquiryArea}
            idEnquiryCity={idEnquiryCity}
            idEnquiryStore={idEnquiryStore}
            idEnquiryComments={idEnquiryComments}
          />
        )}

        {step === 4 && (
          <BookingSummaryStep4
            loading={loading}
            selectedDate={selectedDate}
            selectedSlot={selectedSlot}
            selectedService={selectedService}
            selectedStore={selectedStore}
            Services={Services}
            customerFirstName={customerFirstName}
            customerLastName={customerLastName}
            customerPhone={customerPhone}
            customerEmail={customerEmail}
            building={building}
            area={selectedArea?.value ?? ''}
            city={selectedCity?.value ?? ''}
            selectedNumberofRooms={selectedNumberofRooms}
            selectedServiceMode={selectedServiceMode}
            totalPrice={totalPrice}
            idResidenceType={idResidenceType}
            idRooms={idRooms}
          />
        )}

        {step === 5 && (
          loading ? (
            <div className="step-5"><Loader /></div>
          ) : (
            <TermsAndConditionsPage
              onTermsAcceptedChange={setTermsAccepted}
              serviceType={selectedService}
            />
          )
        )}

        {step === 6 && (
          loading ? (
            <div className="step-5 confirmation-card"><Loader message="Confirming your booking, please wait…" /></div>
          ) : (
            <ConfirmationStep5
              loading={loading}
              confirmed={confirmed}
              customerEmail={customerEmail}
              ServiceName={ServiceName}
              ServiceDescription={ServiceDescription}
              bookingId={bookingId}
              selectedDate={selectedDate}
              ServicePrice={ServicePrice}
              TransactionID={TransactionID}
            />
          )
        )}

        {showReferenceWarning && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h3>Measurement Service Required</h3>
              {refAvailable ? (
                <p>
                  Please complete the <strong>Measurement Service</strong> before booking a Planning
                  Service. Once completed, a reference number will be generated automatically.
                </p>
              ) : (
                <p>
                  No service booking was found for the provided Reference Number / Transaction ID.
                  Please reach out to our support team at <a href="tel:8004532">800 4532</a> for
                  further assistance.
                </p>
              )}
              <button
                className="dialog-close-button"
                onClick={() => setShowReferenceWarning(false)}
              >
                Go Back
              </button>
            </div>
          </div>
        )}

        <StepNavigation
          step={step}
          loading={loading}
          setStep={setStep}
          isStepValid={isStepValid}
          handleNextStep={handleNextStep}
          handleConfirmPayment={handleConfirmPayment}
          selectedService={selectedService}
        />
      </>
    </div>
  );
}
